var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRentspree = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0026 3.03905L3.03905 88.0026C-0.825516 91.8671 -0.825516 98.1328 3.03905 101.997L88.0026 186.961C91.8671 190.825 98.1328 190.825 101.997 186.961L186.961 101.997C190.825 98.1328 190.825 91.8671 186.961 88.0026L101.997 3.03905C98.1328 -0.825516 91.8671 -0.825516 88.0026 3.03905Z",
    fill: "url(#paint0_linear_26_1184)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3125 164.271L65.3125 85.1042H78.5069L85.1041 91.7014L85.1041 184.062L65.3125 164.271Z",
    fill: "#B3D7F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5208 144.479L45.5208 85.1041H65.3125L65.3125 164.271L45.5208 144.479Z",
    fill: "#80BCEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1041 91.7014L138.542 38.2639L155.036 54.7569L85.1041 124.687L45.5208 85.1041H78.5069L85.1041 91.7014Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_1184",
    x1: 116.387,
    y1: 125.603,
    x2: 172.757,
    y2: -6.35592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007ADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815702,
    stopColor: "#00B4CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ECBC"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRentspree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rentspree.fe463d312b4667eaad4363a16353f85b.svg";